export default __webpack_public_path__ + "static/media/logoWhite.3a497242.png";